import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-saf-t-files-selector-importer',
    templateUrl: './saf-t-files-selector-importer.component.html',
    styleUrls: ['./saf-t-files-selector-importer.component.scss'],
    standalone: false
})
export class SafTFilesSelectorImporterComponent {
  @Input() filePicker: UntypedFormGroup;
  @Input() validation: boolean | null;
  @Output() fileArrayBuffer = new EventEmitter<ArrayBuffer>();
  filename: string = null;

  async onFileSelected(event: any) {
    const selectedFile = event.target.files[0];
    this.fileArrayBuffer.emit(null);
    if (selectedFile == null) {
      this.filename = null;
      return;
    }
    this.filePicker.get('selectedFile').setValue(selectedFile)
    this.filename = this.filePicker.get('selectedFile').value.name;
    this.filePicker.get('selectedFile').markAsDirty();

    const arrayBuffer = await this.handleOnload(selectedFile);
    if (arrayBuffer !== null) {
      this.fileArrayBuffer.emit(arrayBuffer);
    }
  }

  handleOnload(file: File): Promise<ArrayBuffer> {
    const fileReader = new FileReader();
    return new Promise<ArrayBuffer>((resolve, reject) => {
      fileReader.onload = () => resolve(fileReader.result as ArrayBuffer);
      fileReader.onerror = () => reject();
      fileReader.readAsArrayBuffer(file);
    });
  }
}
